<template>
  <v-main>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex sx12>
          <h1 class="mt-n2 mb-4">{{ ct.TitleText }}</h1>
          <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
          <v-card v-else raised>
            <v-card-text>
              <v-form ref="form" v-model="valid">
                <v-layout justify-end>
                  <div>
                    <v-checkbox :label="ct.Active" v-model="form.active" :color="'primary'"></v-checkbox>
                  </div>
                </v-layout>
                <v-select
                  v-if="isAdmin()"
                  :items="corporations"
                  v-model="form.corporation"
                  :label="ct.Corporation"
                  :rules="[rules.required]"
                  :no-data-text="ct.NoDataAvailable"
                  @change="loadClaims()"
                ></v-select>
                <v-text-field v-model="form.no" :label="ct.No" :rules="[rules.required]"></v-text-field>
                <v-text-field v-model="form.name" :label="ct.Name" :rules="[rules.required]"></v-text-field>
                <v-text-field v-model="form.description" :label="ct.Description"></v-text-field>
                <v-select
                  chips
                  multiple
                  deletable-chips
                  auto-select-first
                  v-model="form.claims"
                  :label="ct.Claims"
                  :items="claims"
                  :no-data-text="ct.NoDataAvailable"
                ></v-select>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                :loading="submitting"
                :disabled="!valid"
                @click="submit"
                color="success" min-width="97px"
              >{{ct.SaveBtnText}} {{buttonAppend}}</v-btn>
              <v-btn color="primary" @click="preventLeave = false; $router.go(-1)">{{$t("Cancel")}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import { app } from '@/main'
import * as Admin from '@/core/admin'
import * as Security from '@/core/security'
import ct from '@/core/mixins/common-translations'
import rules from '@/core/mixins/common-rules'
import preventLeave from '@/core/mixins/preventLeave'
import * as License from '@/core/license'
import * as Logger from '@/core/logger'

export default {
  mixins: [ct, rules, preventLeave],

  data: () => ({
    dataType: 'userGroup',
    loading: true,
    submitting: false,
    valid: true,
    redirectTo: 'usergroups',
    id: '00000000-0000-0000-0000-000000000000',
    form: {
      no: '',
      name: '',
      description: '',
      corporation: 0,
      claims: [],
      active: true
    },
    corporations: [],
    claims: []
  }),

  methods: {
    isAdmin () {
      return Security.hasAccess([License.adminNo])
    },

    async loadCorporations () {
      const res = await Admin.loadCorporations()
      if (!res.failed) {
        this.corporations = res.data.map(item => {
          return {
            text: item.Name,
            value: item.Id
          }
        })
      }
    },

    logSelectedValues () {
      Logger.log(this.form.claims)
    },

    async loadClaims () {
      const result = await Admin.loadClaims(this.form.corporation)
      if (!result.failed) {
        Logger.log(result)
        this.claims = result.data.map(item => {
          return {
            text: item.Name,
            value: item.Id
          }
        })
      }
    },

    async submit () {
      this.preventLeave = false
      if (this.$refs.form.validate()) {
        this.submitting = true
        const res = await Admin.saveUserGroup({
          Id: this.id,
          No: this.form.no,
          Name: this.form.name,
          Description: this.form.description,
          CorporationId: this.form.corporation,
          Active: this.form.active,
          Claims: this.form.claims
        })
        this.submitting = false
        if (!res.failed) {
          this.$root.$message.showSuccess(this.$t('Saved'))
          this.$router.push({ name: this.redirectTo })
        }
      }
    }
  },

  async mounted () {
    // We use next tick to ensure that app is initialized
    this.$nextTick(() => {
      app.$on('force-update', () => {
        // We need this to ensure that autoLogin re-renders component
        this.$forceUpdate()
      })
    })

    await this.loadCorporations()
    await this.loadClaims()

    if (this.$route.params.id) {
      this.id = this.$route.params.id
      const res = await Admin.loadUserGroup(this.id)
      if (!res.failed) {
        this.form.no = res.data.No
        this.form.name = res.data.Name
        this.form.description = res.data.Description
        this.form.corporation = res.data.CorporationId
        this.form.claims = res.data.Claims.map(v => parseInt(v))
        this.form.active = res.data.DeletedDate == null
      }
    }

    //    this.form.claims = [10,40]

    this.$nextTick(() => {
      this.loading = false
    })
  }
}
</script>
